var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "记录类型设置",
        visible: _vm.dialogVisible,
        "custom-class": "zyyj-dialog",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.handleOpen
      }
    },
    [
      _vm._l(_vm.reportType, function(subject) {
        return _c(
          "el-row",
          {
            key: subject.primaryIndicatorId,
            staticClass: "subject-row",
            attrs: { gutter: 24 }
          },
          [
            _c(
              "el-col",
              { staticClass: "subject-col", attrs: { span: 24 } },
              [
                _c("span", { staticClass: "subject-title" }, [
                  _vm._v(_vm._s(subject.primaryIndicatorName))
                ]),
                _vm._v(" "),
                _c("el-switch", {
                  staticStyle: { "margin-left": "20px" },
                  attrs: {
                    "active-text": subject.enable ? "已启用" : "未启用"
                  },
                  model: {
                    value: subject.enable,
                    callback: function($$v) {
                      _vm.$set(subject, "enable", $$v)
                    },
                    expression: "subject.enable"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("el-col", { attrs: { span: 24 } }, [
              _c("span", { staticClass: "second" }, [_vm._v("记录类型")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "second-subjects" },
                [
                  _vm._l(subject.recordTypeList, function(item, index) {
                    return _c("el-input", {
                      key: index + "recordType",
                      staticStyle: { width: "120px", margin: "0 10px 10px 0" },
                      attrs: { maxlength: 10, clearable: "" },
                      model: {
                        value: item.recordTypeName,
                        callback: function($$v) {
                          _vm.$set(item, "recordTypeName", $$v)
                        },
                        expression: "item.recordTypeName"
                      }
                    })
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        width: "80px",
                        height: "36px",
                        "line-height": "0"
                      },
                      attrs: { disabled: !subject.enable },
                      on: {
                        click: function($event) {
                          return _vm.addSubject(subject)
                        }
                      }
                    },
                    [_vm._v("+ 添加")]
                  )
                ],
                2
              )
            ])
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.closeDialog } },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                disabled: _vm.submitting
              },
              on: { click: _vm.submit }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1901a748", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1901a748","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RecordTypeEditor.vue
// module id = null
// module chunks = 